import API from './api'

export interface ParticipantResult {
  data?: string
  code?: string
  error?: string
}

export const participanteService = {
  async getParticipante(dni: any) {
    const { data } = await API.getRequest(`/participante/${dni}`)
    return data
  },

  async searchEmail(email: any) {
    const { data } = await API.getRequest(
      `/participante/email/${email.toLowerCase()}`
    )
    return data
  },

  async changePassword(token: string | null, password: string) {
    const { data } = await API.postRequestWithAuth(
      '/participante/updatePassword',
      token,
      {
        pass: password,
      }
    )
    return data
  },

  async setAutorPass(element: any): Promise<ParticipantResult> {
    const { data } = await API.postRequest(
      '/participante/setAutorPass',
      element
    )
    return data as ParticipantResult
  },

  async autorPass(element: any): Promise<ParticipantResult> {
    const { data } = await API.postRequest('/participante/autorPass', element)
    return data as ParticipantResult
  },

  async setEvaluador(element: any): Promise<ParticipantResult> {
    const { data } = await API.postRequest(
      '/participante/updatePosAdmin',
      element
    )
    return data as ParticipantResult
  },
}

export default participanteService
